import {
    Box,
    FormControl,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { CalendarMonth } from "@mui/icons-material";

const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
];

const SelectorMes = function ({ onChange, sx, value }) {
    const [mes, setMes] = useState(value ?? 0);

    const handleChange = (event) => {
        const newValue = event.target.value;
        setMes(newValue);
        onChange(newValue);
    };

    return (
        <Box sx={{ ...sx }}>
            <Typography
                variant="subtitle2"
                sx={{
                    fontWeight: 600,
                    color: "#424242",
                    mb: 1.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <CalendarMonth sx={{ fontSize: 18, color: "#1a8a9e" }} />
                Mes
            </Typography>

            <FormControl fullWidth>
                <Select
                    value={mes}
                    onChange={handleChange}
                    renderValue={(selected) => (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: 32,
                                    height: 32,
                                    borderRadius: 1,
                                    bgcolor: "#1a8a9e",
                                    color: "white",
                                    flexShrink: 0,
                                }}
                            >
                                <CalendarMonth sx={{ fontSize: 20 }} />
                            </Box>
                            <Typography
                                variant="body2"
                                sx={{ fontWeight: 600, color: "#2a8fa6" }}
                            >
                                {meses[selected]}
                            </Typography>
                        </Box>
                    )}
                    sx={{
                        bgcolor: "white",
                        borderRadius: 2,
                        height: 56,
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                            borderWidth: 2,
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#80deea",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1a8a9e",
                        },
                        "& .MuiSelect-select": {
                            py: 1.5,
                            display: "flex",
                            alignItems: "center",
                        },
                    }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                borderRadius: 2,
                                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                                mt: 1,
                                maxHeight: 300,
                                "& .MuiMenuItem-root": {
                                    py: 1.25,
                                    px: 2,
                                    "&:hover": {
                                        bgcolor: "#f5f5f5",
                                    },
                                    "&.Mui-selected": {
                                        bgcolor: "#e0f7fa",
                                        fontWeight: 600,
                                        "&:hover": {
                                            bgcolor: "#b2ebf2",
                                        },
                                    },
                                },
                            },
                        },
                    }}
                >
                    {meses.map((mesNombre, i) => (
                        <MenuItem key={i} value={i}>
                            {mesNombre}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default SelectorMes;
